import { TabErrorsActionTypes } from '../../types/tabsErrors';

export const setTabError = (payload: string[] | string) => {
    return { type: TabErrorsActionTypes.SET_ERROR, payload };
};

export const clearTabsError = (payload: boolean) => {
    return { type: TabErrorsActionTypes.CLEAR_ERRORS, payload };
};
